import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function CookieNotice() {
  const [visible, setVisible] = useState(() => localStorage.getItem('blop_cookie_notice_v1') !== 'seen');
  if (!visible) return null;
  const close = () => { localStorage.setItem('blop_cookie_notice_v1', 'seen'); setVisible(false); };
  return <aside className="fixed bottom-4 left-1/2 z-[120] w-[min(92vw,620px)] -translate-x-1/2 rounded-2xl border border-white/15 bg-[#17131d]/95 p-4 shadow-2xl backdrop-blur-xl">
    <div className="flex items-start gap-3">
      <i className="ti ti-cookie mt-0.5 text-xl text-[#b99bf8]" />
      <div className="flex-1 text-xs leading-5 text-white/65">
        <strong className="block text-sm text-white">Cookie essencial de sessão</strong>
        O BlopBoru grava um cookie próprio necessário para manter sua conta conectada e protegida. Não usamos cookies próprios de publicidade ou análise neste momento. Serviços de segurança e login social podem tratar identificadores técnicos.{' '}
        <Link to="/privacy" className="text-[#b99bf8] underline">Saiba mais</Link>.
      </div>
      <button onClick={close} className="rounded-lg bg-white/10 px-3 py-2 text-xs font-bold hover:bg-white/15">Entendi</button>
    </div>
  </aside>;
}
